/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export namespace Wrapper {
  export interface Props {}
}

const styles = StyleSheet.create({
  pipelineWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: `100%`,
    position: 'relative',
  },
});

export const Wrapper: React.FC<Wrapper.Props> = ({ children }) => {
  return (
    <div className={css(styles.pipelineWrapper)} data-it="Pipeline-Wrapper">
      {children}
    </div>
  );
};
